<template>
  <div class="atlas-wrap">
    <div class="w">
      <divider chinese="你若需要 我必努力" english="IF YOU NEED I WILL TRY TO"/>
      <div class="map-wrap">
        <div class="province" @click="handleMarkClick(index, item.citys.length)" :class="active === index ? 'active': ''" v-for="(item, index) in mapData" :key="index" :style="`left: ${item.x}px;top:${item.y}px`">
          <div class="mark" :class="{'active': isMarkShake && index === active}">
            <p class="number" :class="item.citys.length > 0 ? 'active': ''">
              <span>{{item.citys.length}}</span>
            </p>
            <p class="text">{{item.province}}</p>
            <div class="scoll-wrap" v-show="item.citys.length > 0 && cityList">
              <el-scrollbar class="page-component__scroll">
                <div v-for="(i, j) in item.citys" :key="i.url" @click="handleUrl(i)" class="scroll-item">{{j + 1}}. {{i.orgName}}</div>
              </el-scrollbar>
              <p class="triangle el-icon-caret-bottom"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '../divider'
import http from '@/http/index'
import {mapMutations} from 'vuex'
export default {
  data () {
    return {
      active: 0,
      isMarkShake: false,
      cityList: false,
      mapData: {
        beijing: {
          province: '北京',
          x: 666,
          y: 267,
          citys: []
        },
        tianjin: {
          province: '天津',
          x: 681,
          y: 288,
          citys: []
        },
        chongqing: {
          province: '重庆',
          x: 500,
          y: 472,
          citys: []
        },
        shanghai: {
          province: '上海',
          x: 775,
          y: 445,
          citys: []
        },
        guangdong: {
          province: '广东',
          x: 612,
          y: 602,
          citys: []
        },
        heilongjiang: {
          province: '黑龙江',
          x: 802,
          y: 104,
          citys: []
        },
        xinjiang: {
          province: '新疆',
          x: 151,
          y: 217,
          citys: []
        },
        xizang: {
          province: '西藏',
          x: 151,
          y: 394,
          citys: []
        },
        qinghai: {
          province: '青海',
          x: 315,
          y: 345,
          citys: []
        },
        sichuan: {
          province: '四川',
          x: 397,
          y: 471,
          citys: []
        },
        yunnan: {
          province: '云南',
          x: 381,
          y: 583,
          citys: []
        },
        gansu: {
          province: '甘肃',
          x: 330,
          y: 253,
          citys: []
        },
        neimenggu: {
          province: '内蒙古',
          x: 527,
          y: 253,
          citys: []
        },
        ningxia: {
          province: '宁夏',
          x: 504,
          y: 324,
          citys: []
        },
        shanxi1: {
          province: '陕西',
          x: 518,
          y: 399,
          citys: []
        },
        shanxi2: {
          province: '山西',
          x: 583,
          y: 347,
          citys: []
        },
        henan: {
          province: '河南',
          x: 596,
          y: 399,
          citys: []
        },
        hubei: {
          province: '湖北',
          x: 596,
          y: 465,
          citys: []
        },
        hunan: {
          province: '湖南',
          x: 569,
          y: 530,
          citys: []
        },
        guizhou: {
          province: '贵州',
          x: 479,
          y: 551,
          citys: []
        },
        guangxi: {
          province: '广西',
          x: 516,
          y: 603,
          citys: []
        },
        hebei: {
          province: '河北',
          x: 636,
          y: 313,
          citys: []
        },
        shandong: {
          province: '山东',
          x: 679,
          y: 345,
          citys: []
        },
        jiangsu: {
          province: '江苏',
          x: 723,
          y: 400,
          citys: []
        },
        anhui: {
          province: '安徽',
          x: 686,
          y: 434,
          citys: []
        },
        zhejiang: {
          province: '浙江',
          x: 735,
          y: 492,
          citys: []
        },
        jiangxi: {
          province: '江西',
          x: 661,
          y: 515,
          citys: []
        },
        fujian: {
          province: '福建',
          x: 701,
          y: 551,
          citys: []
        },
        taiwan: {
          province: '台湾',
          x: 780,
          y: 595,
          citys: []
        },
        jilin: {
          province: '吉林',
          x: 798,
          y: 180,
          citys: []
        },
        liaoning: {
          province: '辽宁',
          x: 741,
          y: 231,
          citys: []
        },
        hainan: {
          province: '海南',
          x: 549,
          y: 713,
          citys: []
        },
        aomen: {
          province: '澳门',
          x: 637,
          y: 652,
          citys: []
        },
        xianggang: {
          province: '香港',
          x: 655,
          y: 632,
          citys: []
        }
      }
    }
  },
  created () {
    http.getOrglist().then(res => {
      let data = res.data.data
      data.forEach((item, index) => {
        if (item.province === '北京市') {
          this.mapData.beijing.citys.push(item)
        }
        if (item.province === '天津市') {
          this.mapData.tianjin.citys.push(item)
        }
        if (item.province === '重庆市') {
          this.mapData.chongqing.citys.push(item)
        }
        if (item.province === '上海市') {
          this.mapData.shanghai.citys.push(item)
        }
        if (item.province === '广东省') {
          this.mapData.guangdong.citys.push(item)
        }
        if (item.province === '黑龙江省') {
          this.mapData.heilongjiang.citys.push(item)
        }
        if (item.province === '新疆维吾尔自治区') {
          this.mapData.xinjiang.citys.push(item)
        }
        if (item.province === '西藏自治区') {
          this.mapData.xizang.citys.push(item)
        }
        if (item.province === '青海省') {
          this.mapData.qinghai.citys.push(item)
        }
        if (item.province === '四川省') {
          this.mapData.sichuan.citys.push(item)
        }
        if (item.province === '云南省') {
          this.mapData.yunnan.citys.push(item)
        }
        if (item.province === '甘肃省') {
          this.mapData.gansu.citys.push(item)
        }
        if (item.province === '内蒙古自治区') {
          this.mapData.neimenggu.citys.push(item)
        }
        if (item.province === '宁夏回族自治区') {
          this.mapData.ningxia.citys.push(item)
        }
        if (item.province === '陕西省') {
          this.mapData.shanxi1.citys.push(item)
        }
        if (item.province === '山西省') {
          this.mapData.shanxi2.citys.push(item)
        }
        if (item.province === '河南省') {
          this.mapData.henan.citys.push(item)
        }
        if (item.province === '湖北省') {
          this.mapData.hubei.citys.push(item)
        }
        if (item.province === '湖南省') {
          this.mapData.hunan.citys.push(item)
        }
        if (item.province === '贵州省') {
          this.mapData.guizhou.citys.push(item)
        }
        if (item.province === '广西壮族自治区') {
          this.mapData.guangxi.citys.push(item)
        }
        if (item.province === '河北省') {
          this.mapData.hebei.citys.push(item)
        }
        if (item.province === '山东省') {
          this.mapData.shandong.citys.push(item)
        }
        if (item.province === '江苏省') {
          this.mapData.jiangsu.citys.push(item)
        }
        if (item.province === '安徽省') {
          this.mapData.anhui.citys.push(item)
        }
        if (item.province === '浙江省') {
          this.mapData.zhejiang.citys.push(item)
        }
        if (item.province === '江西省') {
          this.mapData.jiangxi.citys.push(item)
        }
        if (item.province === '福建省') {
          this.mapData.fujian.citys.push(item)
        }
        if (item.province === '台湾省') {
          this.mapData.taiwan.citys.push(item)
        }
        if (item.province === '吉林省') {
          this.mapData.jilin.citys.push(item)
        }
        if (item.province === '辽宁省') {
          this.mapData.liaoning.citys.push(item)
        }
        if (item.province === '海南省') {
          this.mapData.hainan.citys.push(item)
        }
        if (item.province === '澳门特别行政区') {
          this.mapData.aomen.citys.push(item)
        }
        if (item.province === '香港特别行政区') {
          this.mapData.xianggang.citys.push(item)
        }
      })
    })
  },
  methods: {
    ...mapMutations(['handleHistoryOrganization']),
    handleMarkClick (index, length) {
      if (this.active === index) {
        this.cityList = !this.cityList
      } else {
        this.active = index
        this.cityList = true
        if (length === 0) {
          this.isMarkShake = true
        } else {
          this.isMarkShake = false
        }
      }
    },
    handleUrl (data) {
      if (!data.url) return false
      window.open('http://www.xinlicloud.com:8017/#/index?abbr=' + data.url)
      this.$emit('jump')
      this.handleHistoryOrganization(data)
    }
  },
  components: {
    divider
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/sass/variable.sass';
/deep/ .page-component__scroll {
  height: 100%;
}
/deep/ .page-component__scroll .el-scrollbar__wrap{
  overflow-x: auto;
}
.atlas-wrap {
  width: 100%;
  height: 980px;
  background: url("~@/assets/images/mapbg.png") no-repeat;
  background-size: cover;
  .w {
    width: $el-center;
    margin: 0 auto;
    .map-wrap {
      width: 930px;
      height: 744px;
      background: url("~@/assets/images/map.png") no-repeat;
      background-size: cover;
      margin:0 auto;
      position: relative;
      .province {
        position: absolute;
        cursor: pointer;
        &.active {
          .mark {
            .scoll-wrap {
              display: block;
            }
          }
        }
        .mark {
          display: flex;
          align-items: center;
          position: relative;
          &.active {
            animation: shake .3s ease-in-out;
          }
          .number {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background: #FD6A00;
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
            position: relative;
            span {
              width: 20px;
              height: 20px;
              position: absolute;
              top: 50%;
              left: 50%;
              margin: -10px -10px;
              z-index: 10;
            }
            &.active::after {
              content: '';
              display: block;
              width: 30px;
              height: 30px;
              background: rgba(253, 106, 0, .4);
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              margin: -15px -15px;
              z-index: 5;
              animation: breath 1s ease-in-out infinite alternate;
            }
            &.active::before {
              content: '';
              display: block;
              width: 40px;
              height: 40px;
              background: rgba(253, 106, 0, .3);
              border-radius: 50%;
              position: absolute;
              top: 50%;
              left: 50%;
              margin: -20px -20px;
              z-index: 2;
              animation: breath 1s ease-in-out infinite alternate;
            }
          }
          .text {
            padding: 3px 10px;
            background: #fff;
            font-size: 12px;
            color: #333333;
            border-radius: 2px;
            margin-left: 5px;
          }
          .scoll-wrap {
            width: 300px;
            height: 150px;
            position: absolute;
            bottom: 0;
            left: 50%;
            background: #fff;
            margin: 40px -152px;
            z-index: 100;
            display: none;
            box-shadow: 0 15px 30px rgba(0,0,0,.3);
            border-radius: 5px;
            .scroll-item {
              font-size: 14px;
              text-align:left;
              padding: 10px 15px;
              &:hover {
                background: rgba(0,0,0,.1);
                color: $el-main-color;
              }
            }
            .triangle {
              color: #fff;
              font-size: 35px;
              text-shadow: 0 5px 5px rgba(0,0,0,.3);
              position: absolute;
              bottom: -21px;
              left: 50%;
              -webkit-transform: translate(-50%);
              transform: translate(-50%);
            }
          }
        }
      }
    }
  }
}
@keyframes breath {
  0% { transform: scale(.8) }
  100% { transform: scale(1)}
}
@keyframes shake {
  0% { transform: translate3d(-2px, 0, 0) }
  25% { transform: translate3d(2px, 0, 0) }
  50% { transform: translate3d(-2px, 0, 0) }
  75% { transform: translate3d(2px, 0, 0) }
  100% { transform: translate3d(0px, 0, 0)}
}
</style>



// WEBPACK FOOTER //
// src/components/home/atlas.vue